module.exports = __webpack_public_path__ + "static/media/buy-chocolate.d52b564d.png";